import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  ValidatePartnershipCardFailure,
  ValidatePartnershipCardRequest,
  ValidatePartnershipCardSuccess,
} from './actions';
import { PartnershipCard, ValidationResponse } from '@models/swagger';
import { ValidatePartnershipCardParams, ValidatePartnershipCardService } from './service';

@Injectable()
export class ValidatePartnershipCardEffects {
  private readonly actions$ = inject(Actions);
  private readonly validatePartnershipCardService = inject(ValidatePartnershipCardService);

  validatePartnershipCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidatePartnershipCardRequest),
      switchMap(({ body, parameters }: { body: PartnershipCard; parameters: ValidatePartnershipCardParams }) =>
        this.validatePartnershipCardService.validatePartnershipCard(body, parameters).pipe(
          map((data: ValidationResponse) => ValidatePartnershipCardSuccess({ data })),
          catchError(error => of(ValidatePartnershipCardFailure({ error })))
        )
      )
    )
  );

}
